module.exports = __webpack_public_path__ + "videos/video-768@2x.97f52ee.webm";